import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  useResetPasswordMutation,
  useSendOtpMutation,
} from "../slices/associateSlice";
import { toast } from "react-toastify";
import { Button, Col, Form, Row } from "react-bootstrap";
import RegistrationContainer from "../components/RegistrationContainer";

const ResetPasswordScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [associateId, setAssociateId] = useState();
  const [gymId, setGymId] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);

  const [sendOtp, { isLoading: otpLoading }] = useSendOtpMutation();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const getOtpHandler = async () => {
    if (!gymId || gymId.trim() === "" || gymId.length !== 4) {
      toast.error("Please enter valid Gym Id");
      return;
    }

    try {
      const resOtp = await sendOtp({
        associateId: gymId,
        token: userInfo?.token,
      }).unwrap();
      setOtp(resOtp?.recentOTP);

      toast.success("OTP recieved Successfully");
      setShowOtpField(true);
    } catch (e) {
      toast.error(e?.data?.error);
    }
  };

  const resetPasswordHandler = async () => {
    if (associateId?.length < 6) toast.error("Please enter valid Login Id");
    else if (otp?.toString().length !== 4)
      toast.error("Please enter valid OTP");
    else
      try {
        await resetPassword({
          associateId: associateId,
          payload: {
            otp,
            newPassword: "abcd@123",
            confirmNewPassword: "abcd@123",
          },
          token: userInfo?.token,
        }).unwrap();

        toast.success(`Password reset successfully for Gym ${gymId}`);
        setGymId("");
        setAssociateId("");
        setOtp("");
        setShowOtpField(false);
      } catch (e) {
        toast.error(e?.data?.error);
      }
  };
  return (
    <>
      <label>
        <strong>ResetPasswordScreen</strong>
      </label>
      <RegistrationContainer>
        <h5>Gym Password Reset</h5>

        <Form.Group as={Row} className="my-3">
          <Form.Label column sm="4">
            Gym ID :
          </Form.Label>

          <Col sm="5">
            <Form.Control
              value={gymId}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setGymId(value);
              }}
              placeholder="Enter Gym ID"
            />
          </Col>
        </Form.Group>
        <Row className="justify-content-center align-items-center">
          <Col xs="auto">
            <Button onClick={getOtpHandler}>Get OTP</Button>
          </Col>
        </Row>

        {showOtpField && (
          <Form.Group as={Row} className="my-3">
            <Form.Label column sm="4">
              Associate Id{" : "}
            </Form.Label>
            <Col sm="5">
              <Form.Control
                type="text"
                pattern="[0-9]*"
                value={associateId}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  setAssociateId(value);
                }}
                placeholder="Enter Associate Id"
              />
            </Col>
            <div style={{ marginTop: "20px" }} />
            <Form.Label column sm="4">
              OTP :
            </Form.Label>

            <Col sm="5">
              <Form.Control value={otp} />
            </Col>
          </Form.Group>
        )}

        {showOtpField && (
          <Row className="justify-content-center align-items-center">
            <Col xs="auto">
              {" "}
              <Button onClick={resetPasswordHandler} disabled={isLoading}>
                Reset Password
              </Button>
            </Col>
          </Row>
        )}
      </RegistrationContainer>
    </>
  );
};

export default ResetPasswordScreen;
